import { FC } from 'react'
import Layout from '../../layout/Layout';
import Wrapper from '../../UI/wrapper/Wrapper';
import styles from './Post.module.scss'
import PortableTextSection from '../../portableTextSection/PortableTextSection';
import SignSection from '../../signSection/SignSection';
import { IPost } from '@/src/assets/interfaces/postInterface';
import NextImage from '../../UI/nextImage/NextImage';
import imageHelper from '@/src/assets/helpers/imageHelper';
import ShareBlock from '../../shareBlock/ShareBlock';
import BonusSection from '../../bonusSection/BonusSection';
import ListingSection from '../../listingSection/ListingSection';
import PostSection from '../../postSection/PostSection';

type TPostPageProps = {
  postData: Partial<IPost>
}

const Post: FC<TPostPageProps> = ({postData}) => {

    const { 
        pageDescription, meta, author, pageSubtitle,
        logo, pageTitle, excerpt, _updatedAt, relatedPosts,
        content, relatedBonuses, relatedListings
    } = postData
    

    return (
        <>
            <Layout meta={meta!}>
                <article>
                    <Wrapper className={styles.Post__wrapper}>
                        <section className={styles.banner}>
                            <div className={styles.banner__left}>
                                <div className={styles.banner__info}>
                                    { pageSubtitle && <span className={styles.section__name}>{pageSubtitle}</span>}
                                    {pageTitle && <h1 className={styles.header}>{pageTitle}</h1>}
                                    {pageDescription && <p className={styles.excerpt}>{pageDescription}</p>}
                                </div>
                                {_updatedAt && 
                                    <ShareBlock 
                                        update={_updatedAt} 
                                        className={styles.share} 
                                        meta={meta!}
                                        title={pageTitle!}
                                        description={excerpt!}
                                        logo={imageHelper(logo).url}
                                    />
                                }
                            </div>
                            <div className={styles.banner__img}>
                                <NextImage 
                                    src={imageHelper(logo).url}
                                    alt={imageHelper(logo).alt ?? `${pageTitle} Logo`}
                                    fill
                                    style={{objectFit:"cover", objectPosition:"center"}}
                                    sizes={`(max-width: 1024px) 40vw, (max-width: 1200px) 38vw, (max-width: 1280px) 40vw, 588px`}
                                />
                            </div>
                        </section>
                    </Wrapper>
                    { content && <PortableTextSection content={content} className={styles.portable__post}/>}
                    <Wrapper className={styles.bottom}>
                        {author 
                            && <SignSection 
                                    author={author} 
                                    update={_updatedAt!} 
                                    meta={meta!} 
                                    title={pageTitle!}
                                    description={excerpt!}
                                    logo={imageHelper(logo).url}
                                />}
                    </Wrapper>
                </article>
                {relatedBonuses && relatedBonuses.bonusesList && <BonusSection data={relatedBonuses}/>}
                {relatedListings && relatedListings.listingsList && <ListingSection data={relatedListings}/>}
                {relatedPosts && relatedPosts.postsList && <PostSection data={relatedPosts}/>}
            </Layout>
        </>
    )
}

export default Post